import { useHookstate } from "@hookstate/core";
import { useDisciplinaryHearings } from "../../hooks/demerit"
import { useGlobalMiscState } from "../../stores/misc";
import DefaultButton from "../default-button/DefaultButton";
import ArrowDown from "../../assets/icons/ArrowDown";
import { getDateOnly, showSnackbar, updateLocalStateRaw, updateMiscState } from "../../misc/utils";
import Edit from "../../assets/icons/Edit";
import Delete from "../../assets/icons/Delete";
import DisciplinaryTableCases from "./DisciplinaryCases";
import Modal from "../Modal/Modal";
import { EditDisciplinaryCase } from "./EditDisciplinaryCase";
import { EditDisciplinaryHearing } from "./EditDisciplinaryHearing";
import { demeritsApi } from "../../api/api";
import { simpleGetter } from "../../actions/common";

export const DisciplinaryHearing = ({ hearing }: { hearing: any }) => {
    const miscState = useGlobalMiscState();
    const localState = useHookstate({});
    const state: Record<string, any> = localState.get();
    const isOpen = Boolean(state.isOpen)

    const toggleOpen = () => {
        updateLocalStateRaw(localState, 'isOpen')(!isOpen)
    }

    const onEdit = () => {
        miscState.setBatch({
            currentDisciplinaryHearing: hearing,
            editDisciplinaryCaseHearingModalOpen: true
        })
    }

    const onDelete = async () => {
        const response = await simpleGetter(demeritsApi.deleteDisciplinaryHearing, hearing.id)
        showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
        if (response.success) {
            miscState.setBatch({
                disciplinaryHearingsTriggerFetch: (miscState.get('disciplinaryHearingsTriggerFetch') || 0) + 1
            })
        }
    }

    return (
        <div className="flex flex-col bg-valley-background-blue p-2 gap-2 rounded-xl">
            <div className="flex flex-row p-4 gap-4 items-center">
                <DefaultButton
                    Icon={ArrowDown}
                    onClick={toggleOpen}
                    additionalStyle={`px-1 ${isOpen
                        ? 'bg-valley-main text-white'
                        : 'bg-transparent border border-valley-gray text-valley-gray'
                        }`}
                    iconStyle={`transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                />
                <div className="flex flex-row flex-1">
                    <span className="text-valley-black font-medium text-xl leading-[22px]">
                        Заседание №{hearing.id}
                    </span>
                </div>
                <p className="flex flex-row gap-1 font-medium text-[15px] leading-[19.5px]">
                    <span className="text-valley-gray">
                        Дата:
                    </span>
                    <span className="text-valley-black">
                        {getDateOnly(hearing.start_date)}
                    </span>
                </p>
                <p className="flex flex-row gap-1 font-medium text-[15px] leading-[19.5px]">
                    <span className="text-valley-gray">
                        Время:
                    </span>
                    <span className="text-valley-black">
                        {hearing.start_time.slice(0, 5)}-{hearing.end_time.slice(0, 5)}
                    </span>
                </p>
                <div className="flex flex-row flex-1 gap-2 justify-end">
                    <DefaultButton
                        Icon={Edit}
                        buttonText="Редактировать"
                        additionalStyle="px-4 py-[6px] border border-valley-light-gray text-valley-gray"
                        onClick={onEdit}
                    />
                    <DefaultButton
                        Icon={Delete}
                        buttonText="Удалить"
                        additionalStyle="px-4 py-[6px] border border-valley-red text-valley-red"
                        onClick={onDelete}
                    />
                </div>
            </div>
            {isOpen && hearing.cases.map((c: any) => (
                <DisciplinaryTableCases caseItem={c} hideCheckbox={true} />
            ))}
        </div>
    )
}

export const DisciplinaryHearings = () => {
    const miscState = useGlobalMiscState();
    const editDisciplinaryCaseHearingModalOpen = Boolean(miscState.get('editDisciplinaryCaseHearingModalOpen'));
    const disciplinaryHearingsTriggerFetch = miscState.get('disciplinaryHearingsTriggerFetch') || 0;
    const hearings = useDisciplinaryHearings(disciplinaryHearingsTriggerFetch)

    const onEdit = () => {

    }

    return (
        <div className="flex flex-col">
            {hearings.map(h => (
                <DisciplinaryHearing hearing={h} />
            ))}
            <Modal
                additionalClassName='!w-[90%] h-[90%] rounded-xl flex flex-col p-8'
                visible={editDisciplinaryCaseHearingModalOpen}
                setVisible={updateMiscState('editDisciplinaryCaseHearingModalOpen')}
            >
                <EditDisciplinaryHearing />
            </Modal>
        </div>
    )
}